// Environment configuration for DevSandbox Pro
// This handles different environments (development, production, etc.)

const getApiBaseUrl = () => {
  // Priority: Environment variable > Current window location > Fallback
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL;
  }
  
  // In production, use the same host as the frontend
  if (process.env.NODE_ENV === 'production' && typeof window !== 'undefined') {
    const { protocol, hostname, port } = window.location;
    // Assume backend runs on port 8000 in production, or same port if different
    const backendPort = port === '3000' ? '8000' : port;
    return `${protocol}//${hostname}:${backendPort}/api/v1`;
  }
  
  // Development fallback
  return 'http://localhost:8000/api/v1';
};

const getWebSocketUrl = () => {
  // Priority: Environment variable > Current window location > Fallback
  if (process.env.REACT_APP_WS_URL) {
    return process.env.REACT_APP_WS_URL;
  }
  
  // In production, use the same host as the frontend
  if (process.env.NODE_ENV === 'production' && typeof window !== 'undefined') {
    const { protocol, hostname, port } = window.location;
    const wsProtocol = protocol === 'https:' ? 'wss:' : 'ws:';
    // Assume backend runs on port 8000 in production, or same port if different
    const backendPort = port === '3000' ? '8000' : port;
    return `${wsProtocol}//${hostname}:${backendPort}/ws`;
  }
  
  // Development fallback
  return 'ws://localhost:8000/ws';
};

const getBackendBaseUrl = () => {
  // Get base URL without /api/v1 suffix
  const apiUrl = getApiBaseUrl();
  return apiUrl.replace('/api/v1', '');
};

const config = {
  API_BASE_URL: getApiBaseUrl(),
  WS_URL: getWebSocketUrl(),
  BACKEND_BASE_URL: getBackendBaseUrl(),
  IS_PRODUCTION: process.env.NODE_ENV === 'production',
  IS_DEVELOPMENT: process.env.NODE_ENV === 'development',
};

export default config;
